import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import {getIconComponentByType} from "../../utils/assets";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Export = ({tittle, onSave, avatarIcon, actionIcon = "saveAlt", isAction, isDisabled, isLoading, loadingMessage}) => {
  return (
    <Card raised>
      <CardHeader
        disableTypography
        sx={{
          padding: "3px 5px 3px 16px"
        }}
        avatar={
          getIconComponentByType(avatarIcon)
        }
        action={
          !isAction && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {isLoading && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>
                  <CircularProgress size={16} />
                  <Typography variant="caption" sx={{ fontSize: '0.75rem' }}>
                    {loadingMessage || 'Downloading...'}
                  </Typography>
                </Box>
              )}
              <IconButton onClick={onSave} disabled={isDisabled || isLoading}>
                {getIconComponentByType(actionIcon)}
              </IconButton>
            </Box>
          )
        }
        title={<Typography variant="body1">{tittle}</Typography>}
      />
    </Card>
  )
}

export default Export